import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import PriceLabel from '@prisjakt/ui-price-label';
import Currency from '@prisjakt/ui-currency';
import { AppContext } from '@prisjakt/ui-app-context';

const ShippingLabel = ({ inclShipping, exclShipping, toneDown }) => {
  const { t } = useContext(AppContext);
  let shippingValue;
  if (!inclShipping) {
    shippingValue = t('product', 'price.unknown-shipping');
  } else {
    shippingValue =
      inclShipping === exclShipping
        ? t('product', 'price.free-shipping')
        : t('product', 'price.including-shipping', {
            price: <Currency key="currency" price={inclShipping} />,
          });
  }

  return (
    <PriceLabel
      bold={false}
      value={shippingValue}
      styling={toneDown ? 'lighten' : 'secondary'}
    />
  );
};

const { string, bool, number, oneOfType } = PropTypes;
ShippingLabel.propTypes = {
  inclShipping: oneOfType([string, number]),
  exclShipping: oneOfType([string, number]).isRequired,
  toneDown: bool,
};

ShippingLabel.defaultProps = {
  toneDown: false,
  inclShipping: null,
};

export default memo(ShippingLabel);
